import Button from 'src/components/Common/@electron/Button';
import { RebatesModalButtonsInterface } from '../../../../types';

const RebatesModalButtons = ({
  offerLearnMore,
  closeRebateModal,
  primaryButtonText,
  secondaryButtonText,
}: RebatesModalButtonsInterface) => {
  return (
    <div className="md:flex justify-center w-full">
      <a
        href={offerLearnMore}
        target="_blank"
        rel="noreferrer"
        className="my-12 md:m-12 w-full md:max-w-[220px]"
      >
        <Button size="sm" className="w-full" variant="secondary">
          {secondaryButtonText}
        </Button>
      </a>
      <Button
        size="sm"
        className="my-12 md:m-12 w-full md:max-w-[220px]"
        onClick={closeRebateModal}
      >
        {primaryButtonText}
      </Button>
    </div>
  );
};

export default RebatesModalButtons;
